import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Misconceptions from './components/Misconceptions';
import BigIdea from './components/BigIdea';
import HeroJourney from './components/HeroJourney';
import Instructor from './components/Instructor';
import SecretKnowledge from './components/SecretKnowledge';
import Curriculum from './components/Curriculum';
import ValueStack from './components/ValueStack';
import Pricing from './components/Pricing';
import PricingLadder from './components/PricingLadder';
import CostOfInaction from './components/CostOfInaction';
import BaziExplanation from './components/BaziExplanation';
import FAQ from './components/FAQ';
import Registration from './components/Registration';
import Footer from './components/Footer';
import SocialProofPopup from './components/SocialProofPopup';
import AdminDashboard from './components/AdminDashboard';
import SuccessPage from './components/SuccessPage';

function LandingPage() {
  return (
    <>
      <Hero />
      <Misconceptions />
      <BigIdea />
      <HeroJourney />
      <Instructor />
      <SecretKnowledge />
      <Curriculum />
      <ValueStack />
      <Pricing />
      <PricingLadder />
      <CostOfInaction />
      <BaziExplanation />
      <FAQ />
      <Registration />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white font-sans selection:bg-brand-red selection:text-white overflow-x-hidden">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/payment-success" element={<SuccessPage />} />
          </Routes>
        </main>
        <Footer />
        <SocialProofPopup />
      </div>
    </Router>
  );
}

export default App;